import { StackViewport, VolumeViewport, VideoViewport, utilities as csUtils, } from '@cornerstonejs/core';
import filterAnnotationsWithinSlice from './filterAnnotationsWithinSlice';
import annotationFrameRange from '../annotationFrameRange';
const baseUrlExtractor = /(videoId:|imageId:|volumeId:)([a-zA-Z]*:)/;
export default function filterAnnotationsForDisplay(viewport, annotations) {
    if (viewport instanceof StackViewport) {
        const imageId = viewport.getCurrentImageId();
        const colonIndex = imageId.indexOf(':');
        const imageURI = imageId.substring(colonIndex + 1);
        return annotations.filter((annotation) => {
            if (!annotation.isVisible) {
                return false;
            }
            const imageId = annotation.metadata.referencedImageId;
            if (imageId === undefined) {
                return false;
            }
            const colonIndex = imageId.indexOf(':');
            const referenceImageURI = imageId.substring(colonIndex + 1);
            return referenceImageURI === imageURI;
        });
    }
    else if (viewport instanceof VideoViewport) {
        const frameOfReferenceUID = viewport.getFrameOfReferenceUID();
        return annotations.filter((annotation) => {
            if (!annotation.isVisible) {
                return false;
            }
            if (annotation.metadata.FrameOfReferenceUID !== frameOfReferenceUID) {
                return false;
            }
            const testURI = annotation.metadata.referencedImageId.replace(baseUrlExtractor, '');
            if (!viewport.hasImageURI(testURI)) {
                return false;
            }
            const range = annotationFrameRange.getFrameRange(annotation);
            const frameNumber = viewport.getFrameNumber();
            if (Array.isArray(range)) {
                return frameNumber >= range[0] && frameNumber <= range[1];
            }
            return Math.abs(frameNumber - range) <= 5;
        });
    }
    else if (viewport instanceof VolumeViewport) {
        const camera = viewport.getCamera();
        const { spacingInNormalDirection } = csUtils.getTargetVolumeAndSpacingInNormalDir(viewport, camera);
        return filterAnnotationsWithinSlice(annotations, camera, spacingInNormalDirection);
    }
    else {
        throw new Error(`Viewport Type ${viewport.type} not supported`);
    }
}
//# sourceMappingURL=filterAnnotationsForDisplay.js.map